import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';

class NoCreditDialog extends React.Component {

  handleClose = () => {
    const { close } = this.props
    close()
  };

  render() {
    const { open } = this.props;

    return (


        <Dialog
          fullScreen={false}
          open={open}
          onClose={this.handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">{"Campaign added succesfully!"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
            You have successfully added/updated your campaign. If your campaign is turned on, we will start sending you a steady flow of leads based on your campaign's position in the queue and on our current buyer activity (typically within 24 hours). To make updates to a lead campaign, you will need to go to the Campaign tab in your dashboard. Simply select the campaign you would like to update, click  'Edit Campaign', and resubmit the campaign with your updated specifications. 
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary" autoFocus>
              Ok
            </Button>
          </DialogActions>
        </Dialog>

    );
  }
}

NoCreditDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
};

export default withMobileDialog()(NoCreditDialog);


// WEBPACK FOOTER //
// ./src/components/Leads/Campaigns/ManageCampaign/Options/Dialogs/CampiagnSuccessfulDialog.js